import api from '../../api/'
const state = {
    all:[],
    all_appro_entite:[],
    all_appro_guichet:[]
}

const getters= {
    rows(state){
        let data = []
        let row = {
            id: "",
            user_nom: "",
            agence_nom_source: "",
            agence_ville_source: "",
            agence_nom_destination: "",
            guichet_nom_source: "",
            montant: "",
            approvisionnementable_type: "",
            destination:"",
            created_at: null,
            updated_at: null,
            deleted_at: null,
            btn:""
        }
        state.all.forEach(element => {  
            console.log("mes appros ",element)
            row = {
                id: element.id,
                user_nom: element.user_nom == null ? null : element.user_nom.toUpperCase(), 
                agence_nom_source: element.agence_nom_source == null ? null : element.agence_nom_source.toUpperCase(), 
                agence_ville_source: element.agence_ville_source == null ? null : element.agence_ville_source.toUpperCase(), 
                agence_nom_destination: element.agence_nom_destination == null ? null : element.agence_nom_destination.toUpperCase(), 
                guichet_nom_source: element.guichet_nom_source == null ? null : element.guichet_nom_source.toUpperCase(), 
                montant: element.montant.toLocaleString(),
                approvisionnementable_type: element.approvisionnementable_type.substring(4).toUpperCase(),
                destination: element.destination,
                //approvisionnementable: element.approvisionnementable === null ? null : element.approvisionnementable.nom_commercial || element.approvisionnementable.nom,
                created_at: element.created_at,
                deleted_at: element.deleted_at,
                updated_at: element.updated_at
                //btn: "<router-link to='/theme/guichets/show/"+element.id+"'><button class='btn btn-pill btn-success'><i class='fa fa-plus'></i></button></router-link><button class='btn btn-pill btn-info'><i class='fa fa-pencil'></i></button><button class='btn btn-pill btn-danger'><i class='fa fa-trash'></i></button>"
            }
            data.push(row)
        });
        return data;
    },
    rowsEntite(state){
        let data = []
        let row = {
            id: "",
            user_nom: "",
            agence_nom_source: "",
            agence_ville_source: "",
            agence_nom_destination: "",
            guichet_nom_source: "",
            montant: "",
            approvisionnementable_type: "",
            destination: "",
            created_at: null,
            updated_at: null,
            deleted_at: null,
            btn: ""
        }
        state.all_appro_entite.forEach(element => {
            row = {
                id: element.id,
                user_nom: element.user_nom == null ? null : element.user_nom.toUpperCase(),
                agence_nom_source: element.agence_nom_source == null ? null : element.agence_nom_source.toUpperCase(),
                agence_ville_source: element.agence_ville_source == null ? null : element.agence_ville_source.toUpperCase(),
                agence_nom_destination: element.agence_nom_destination == null ? null : element.agence_nom_destination.toUpperCase(),
                guichet_nom_source: element.guichet_nom_source == null ? null : element.guichet_nom_source.toUpperCase(),
                montant: element.montant.toLocaleString(),
                approvisionnementable_type: element.approvisionnementable_type.substring(4).toUpperCase(),
                destination: element.destination,
                //approvisionnementable: element.approvisionnementable === null ? null : element.approvisionnementable.nom_commercial || element.approvisionnementable.nom,
                created_at: element.created_at,
                deleted_at: element.deleted_at,
                updated_at: element.updated_at
                //btn: "<router-link to='/theme/guichets/show/"+element.id+"'><button class='btn btn-pill btn-success'><i class='fa fa-plus'></i></button></router-link><button class='btn btn-pill btn-info'><i class='fa fa-pencil'></i></button><button class='btn btn-pill btn-danger'><i class='fa fa-trash'></i></button>"
            }
            data.push(row)
        });
        return data;
    },
    rowsGuichet(state){
        let data = []
        let row = {
            id: "",
            user_nom: "",
            agence_nom_source: "",
            agence_ville_source: "",
            agence_nom_destination: "",
            guichet_nom_source: "",
            montant: "",
            approvisionnementable_type: "",
            destination: "",
            created_at: null,
            updated_at: null,
            deleted_at: null,
            btn: ""
        }
        state.all_appro_guichet.forEach(element => {  
            console.log("ele ",element)         
            row = {
                id: element.id,
                user_nom: element.user_nom == null ? null : element.user_nom.toUpperCase(),
                agence_nom_source: element.agence_nom_source == null ? null : element.agence_nom_source.toUpperCase(),
                agence_ville_source: element.agence_ville_source == null ? null : element.agence_ville_source.toUpperCase(),
                agence_nom_destination: element.agence_nom_destination == null ? null : element.agence_nom_destination.toUpperCase(),
                guichet_nom_source: element.guichet_nom_source == null ? null : element.guichet_nom_source.toUpperCase(),
                montant: element.montant.toLocaleString(),
                approvisionnementable_type: element.approvisionnementable_type.substring(4).toUpperCase(),
                destination: element.destination,
                //approvisionnementable: element.approvisionnementable === null ? null : element.approvisionnementable.nom_commercial || element.approvisionnementable.nom,
                created_at: element.created_at,
                deleted_at: element.deleted_at,
                updated_at: element.updated_at
                //btn: "<router-link to='/theme/guichets/show/"+element.id+"'><button class='btn btn-pill btn-success'><i class='fa fa-plus'></i></button></router-link><button class='btn btn-pill btn-info'><i class='fa fa-pencil'></i></button><button class='btn btn-pill btn-danger'><i class='fa fa-trash'></i></button>"
            }
            data.push(row)
        });
        return data;
    }
}
const mutations= {
    setAppro(state, appro) {
        state.all = appro
    },
    setApproEntite(state, appro) {
        state.all_appro_entite = appro
    },
    setApproGuichet(state, appro) {
        state.all_appro_guichet = appro
    },
    addApproEntite(state, appro) {
        state.all_appro_entite.push(appro)
    },
    addApproGuichet(state, appro) {
        state.all_appro_guichet.push(appro)
    }
}

const actions={
    get_all_approvisionnements({ commit }, serverParams){
        return api.appro.get_all_approvisionnements(serverParams).then((response)=>{
            console.log('response appro ',response)
            commit('setAppro', response.data.data.data)
            return response.data.data
        })
    },
    get_all_approvisionnements_own({ commit }, serverParams){
        return api.appro.get_all_approvisionnements_own(serverParams).then((response)=>{
            commit('setAppro', response.data.data.data)
            return response.data.data
        })
    },
    get_all_approvisionnements_by_users({ commit }, user_id){
        return api.appro.get_all_approvisionnements_by_users(user_id).then((response)=>{
            commit('setAppro', response.data.data.data)
            return response.data.data.data
        })
    },
    get_all_approvisionnemententite({ commit }){
        return api.appro.get_all_approvisionnemententite().then((response)=>{
            commit('setApproEntite', response.data.data.data)
            return response.data.data.data
        })
    },
    get_all_approvisionnemententite_by_entity({ commit },id){
        return api.appro.get_all_approvisionnemententite_by_entity(id).then((response)=>{
            commit('setApproEntite', response.data.data.data)
            return response.data.data.data
        })
    },
    get_all_approvisionnementByAgence({ commit },id){
        return api.appro.get_all_approvisionnementByAgence(id).then((response)=>{
            commit('setApproEntite', response.data.data.data)
            return response.data.data.data
        })
    },
    get_all_approvisionnemententite_by_atm({ commit },id){
        return api.appro.get_all_approvisionnemententite_by_atm(id).then((response)=>{
            commit('setApproGuichet', response.data.data.data)
            return response.data.data.data
        })
    },
    get_all_approvisionnementguichet({ commit }){
        return api.appro.get_all_approvisionnementguichet().then((response)=>{
            commit('setApproGuichet', response.data.data.data)
            return response.data.data.data
        })
    },
    post_approvisionnementEntite({commit},appro){
        return api.appro.post_approvisionnementEntite(appro).then((response)=>{
            
            //commit('addApproEntite', response.data.data)
            return response.data
        })
        .catch(error=>{
            return error.response.data
        })
    },
    post_approvisionnementGuichet({commit},appro){
        return api.appro.post_approvisionnementGuichet(appro).then((response)=>{
            //console.log('ma response ', response.data.data)
            //commit('addApproGuichet', response.data.data)
            return response.data
        })
        .catch(error => {
            return error.response.data
        })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
